import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, useHistory } from "react-router-dom";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./function-components/PageLayout";
import SessionDetailsToNominateTabs from "./function-components/BusinessPOC/SessionDetailsToNominateTabs";
import SMETabs from "./function-components/SME/SMETabs";
import THContent from "./function-components/TH/THContent";
import SMESessions from "./function-components/SME/SMESessions";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { checkUserPresent } from "./function-components/Redux/SmeSlice";
import { useDispatch } from "react-redux";
import Axios from "axios";
import { TabProvider } from "./TabContext";

//const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";
function App({ pca }) {
 // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
 const history = useHistory();
 const navigationClient = new CustomNavigationClient(history);

 pca.setNavigationClient(navigationClient);

 return (
  <MsalProvider instance={pca}>
   <PageLayout>
    <div container justifyContent="center">
     <Pages />
    </div>
   </PageLayout>
  </MsalProvider>
 );
}
function Pages() {
 const [accessToken, setAccessToken] = useState(null);
 const msalInstance = new PublicClientApplication(msalConfig);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 let loggedInEnterpriseId = "";
 if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 const dispatch = useDispatch();

 useEffect(() => {
  if (activeAccount) {
   console.log("inside useEffect 11");
   fetchAccessToken();
   console.log("inside useEffect 2");
  }
 }, [activeAccount]);
 const fetchAccessToken = async () => {
  if (!activeAccount)
   throw Error(
    "No active account! Verify a user has been signed in and setActiveAccount has been called."
   );
  try {
   console.log(activeAccount);
   const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: activeAccount,
   });
   const bearer = `Bearer ${response.accessToken}`;
   //    setAccessToken(bearer);
   //    localStorage.setItem("token", bearer);
   //    dispatch(checkUserPresent(loggedInEnterpriseId, bearer));
   console.log("inside try block");

   Axios.get(`${baseURL}/loginUser`, {
    headers: {
     Authorization: bearer,
     "Content-Type": "application/json",
    },
   })
    .then((res) => {
     console.log("login success", res.data.token);
     const bearer = `Bearer ${res.data.token}`;
     setAccessToken(bearer);
     localStorage.setItem("token", bearer);
     dispatch(checkUserPresent(loggedInEnterpriseId, bearer));
    })
    .catch((err) => {
     console.error("error is", err);
    });
  } catch (error) {
   console.error("Error fetching access token:", error);
   localStorage.clear();
  }
 };

 // useEffect(() => {
 //     dispatch(checkUserPresent(loggedInEnterpriseId, accessToken));
 // }, [accessToken]);

 return (
  <>
  <TabProvider>
   <Router basename={"/LKMTrainingNomination"}>
    <SearchNav />
    <Navbarmenu />
    <Switch>
     <Route exact path="/home">
      <Home />
     </Route>
     <Route exact path="/sessionDetailsToNominate">
      <SessionDetailsToNominateTabs />
     </Route>
     <Route exact path="/SME">
      {/* <SMETabs /> */}
      <SMESessions />
     </Route>
     <Route exact path="/TH">
      <THContent />
     </Route>
     <Route exact path="/">
      <Home />
     </Route>
    </Switch>
    <Footer />
   </Router>
  </TabProvider>
  </>
 );
}

export default App;
